/**
 * ISO из бэкенда (в БД время в UTC): если в строке нет Z или смещения часового пояса,
 * ECMAScript трактует дату как локальную — тогда на экране оказываются «часы UTC» (например −3 ч к МСК).
 * Та же логика, что parseSessionTimeAsUtc в MyShiftCardV2.
 */
export function parseApiDateTimeUtc(isoString: string | undefined | null): Date {
  if (isoString == null || isoString === '') return new Date();
  const s = String(isoString).trim();
  if (s.endsWith('Z') || /[+-]\d{2}:?\d{2}$/.test(s)) return new Date(s);
  return new Date(`${s}Z`);
}

/**
 * Форматирует часы в формат "часы:минуты"
 * @param hours - количество часов в дробном формате (например, 8.067)
 * @returns строка в формате "8ч 4м" или "8ч 30м"
 */
export const formatHours = (hours: number): string => {
  if (hours <= 0) return '0ч 0м';
  
  const wholeHours = Math.floor(hours);
  const minutes = Math.round((hours - wholeHours) * 60);
  
  if (minutes === 0) {
    return `${wholeHours}ч`;
  }
  
  return `${wholeHours}ч ${minutes}м`;
};

/**
 * Форматирует часы для отображения в статистике
 * @param hours - количество часов в дробном формате
 * @returns строка в формате "8ч 4м" с округлением до 1 знака после запятой для дробных часов
 */
export const formatHoursForStats = (hours: number): string => {
  if (hours <= 0) return '0ч 0м';
  
  // Округляем до 1 знака после запятой для статистики
  const roundedHours = Math.round(hours * 10) / 10;
  const wholeHours = Math.floor(roundedHours);
  const minutes = Math.round((roundedHours - wholeHours) * 60);
  
  if (minutes === 0) {
    return `${wholeHours}ч`;
  }
  
  return `${wholeHours}ч ${minutes}м`;
};
